export default "__VITE_ASSET__C27OyD8c__"